import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

type ZtvPayloadState = string | number | boolean | Record<string, unknown> | unknown[] | null;

/**
 * ZtvStateService
 * --------------------------------------------------------------------
 * ZTV and ZTV-output related reactive state (input values, edited
 * flags, input errors, restore-button clicks) previously inline on
 * `ApiService`.
 *
 * Public names mirror the legacy `ApiService` API so consumers do not
 * need to change.
 */
@Injectable({ providedIn: "root" })
export class ZtvStateService {
  readonly setZtvValues = new BehaviorSubject<ZtvPayloadState>("");
  readonly getZtvValues: Observable<ZtvPayloadState> = this.setZtvValues.asObservable();

  readonly setztvoutputValues = new BehaviorSubject<ZtvPayloadState>("");

  readonly setZtvEdited = new BehaviorSubject<ZtvPayloadState>("");
  readonly getZtvEdited: Observable<ZtvPayloadState> = this.setZtvEdited.asObservable();

  readonly setztvInputError = new BehaviorSubject<boolean>(false);
  readonly getztvInputError: Observable<boolean> = this.setztvInputError.asObservable();

  readonly ztvRestoreBtnClick = new BehaviorSubject<ZtvPayloadState>("");
  readonly getztvRestoreBtnClick: Observable<ZtvPayloadState> = this.ztvRestoreBtnClick.asObservable();

  readonly ztvoutputRestoreBtnClick = new BehaviorSubject<ZtvPayloadState>("");

  // --- Setters (names match legacy ApiService) ----------------------
  sendZtvObj(data: ZtvPayloadState): void {
    this.setZtvValues.next(data);
  }
  sendztvoutputObj(data: ZtvPayloadState): void {
    this.setztvoutputValues.next(data);
  }
  ztvEditedVal(data: ZtvPayloadState): void {
    this.setZtvEdited.next(data);
  }
  ztvInputError(data: boolean): void {
    this.setztvInputError.next(data);
  }
  setZtvRestoreBtnClick(value: ZtvPayloadState): void {
    this.ztvRestoreBtnClick.next(value);
  }
  setztvoutputRestoreBtnClick(value: ZtvPayloadState): void {
    this.ztvoutputRestoreBtnClick.next(value);
  }
}
